export const COMPONENT_NAME = "ui-button";
